module.exports = __webpack_public_path__ + "static/media/filter.2985b597.svg";